<template>
    <publico></publico>
</template>
<script>
import publico from "./publico"
export default { components: { publico } }
</script>
